import React from "react";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import PaymentIcon from "@mui/icons-material/Payment";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const adminBenefits = [
  {
    icon: <DashboardIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Gestión Centralizada",
    description:
      "Accedé a todas tus reservas, clientes y pagos desde un solo lugar.",
    bgColor: "#565254",
  },
  {
    icon: <PeopleIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Control de Clientes",
    description:
      "Visualizá el historial de tus clientes, segmenta información y mantén todo organizado.",
    bgColor: "#565254",
  },
  {
    icon: <PaymentIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Pagos Simplificados",
    description:
      "Administra cobros, facturación y pagos pendientes de forma eficiente.",
    bgColor: "#565254",
  },
  {
    icon: <CalendarTodayIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Disponibilidad en Tiempo Real",
    description:
      "Consulta la disponibilidad de tus habitaciones o servicios en un solo clic.",
    bgColor: "#565254",
  },
];

function HeroAdminPanel() {
  return (
    <Box
      sx={{
        scrollSnapAlign: "start",
        background: "linear-gradient(0deg, #d2c2f2, #903AF2)",

        height: "100%",
        color: "white",
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Información principal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              color={"#fff"}
              sx={{ fontFamily: "'Red Hat Display', sans-serif" }}
            >
              Panel Administrativo Ubika
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontFamily: "'Merriweather Sans', sans-serif",
                color: "#fff",
              }}
            >
              Tomá el control total de tu negocio con una plataforma simple y
              poderosa. El panel de Ubika te permite gestionar todo desde un
              solo lugar: reservas, clientes, pagos, disponibilidad y más.
              Accedé desde tu computadora o celular, con una interfaz clara y
              pensada para que puedas ahorrar tiempo y evitar errores.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#EE964B",
                color: "#ffffff",
                fontWeight: "bold",
                fontFamily: "'Red Hat Display', sans-serif",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#d97e3e",
                },
              }}
            >
              Ver Demo
            </Button>
          </Grid>

          {/* Beneficios principales */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {adminBenefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: benefit.bgColor,
                      color: "#ffffff",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    {benefit.icon}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mt: 2 }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2">
                      {benefit.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroAdminPanel;
